import { render } from "./FolderView.vue?vue&type=template&id=55a2cdf8&scoped=true"
import script from "./FolderView.vue?vue&type=script&lang=js"
export * from "./FolderView.vue?vue&type=script&lang=js"

import "./FolderView.vue?vue&type=style&index=0&id=55a2cdf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a2cdf8"]])

export default __exports__